import { ChapterType } from '../_types';

export default function getNextChapter(
  flatToc: ChapterType[],
  currentChapterId: number
): ChapterType | null {
  const currentIndex = flatToc.findIndex((item) => item.id === currentChapterId);
  if (currentIndex === -1) {
    return null;
  }

  for (let index = currentIndex + 1; index < flatToc.length; index += 1) {
    const item = flatToc[index];
    if (item?.type === 'title-2' || item?.type === 'MCQ') {
      return item;
    }
  }

  return null;
}
